export const environment = {
	production: true,
	webappName: 'KVVM Ikea',
	appVersionAddon: '',
	api_endpoint: 'https://app.kvvm.nl/api/v1/',
	sentry: 'https://587d17c2a6d5fc555c057e4583040f2b@o4507735602298880.ingest.de.sentry.io/4508284140716112'
};
